(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6700],{

/***/ 32668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(92222);

var _dotenv = __webpack_require__(59738);

var _CONTRACTS = _interopRequireDefault(__webpack_require__(37747));

(0, _dotenv.config)();
var contractId = {
  BASE: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_BASE,
  UPGRADE: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_UPGRADE,
  TERMS_AND_CONDITIONS: process.env.MICROSERVICE_CONSENTS_TERMS_UUID,
  SUPERAPPLY: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_SUPERAPPLY
};
var _default = {
  CANDIDATE: {
    CANDIDATES: function CANDIDATES(candidateId) {
      return "".concat(process.env.URL_MICROSERVICE_CANDIDATES, "/v1/candidates/").concat(candidateId);
    }
  },
  CREDIT_CARD: {
    INSERT: "".concat(process.env.URL_MICROSERVICE_CREDIT_CARD_SERVER, "/inserir-dados-cartao/salvar-cartao/")
  },
  JOB_SEARCH: {
    PROFILE_SUMMARIES: function PROFILE_SUMMARIES(profileId, candidateId) {
      return "".concat(process.env.URL_MICROSERVICE_JOBS_SEARCH, "/v1/profiles/").concat(profileId, "/summaries/?_candidate.id=").concat(candidateId);
    },
    PLAN_CANDIDATE_SUMMARIES: "".concat(process.env.URL_MICROSERVICE_JOBS_SEARCH, "/v1/summaries/?_fields=jobs,filters.profile.id&profile.id=")
  },
  PAYMENT: {
    PLAN: function PLAN(profileId, candidateId, hashPlans) {
      var url = "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/plans?_candidate.id=").concat(candidateId, "&planCandidate.id=").concat(profileId);
      if (hashPlans) return "".concat(url, "&_hash=").concat(hashPlans);
      return url;
    },
    GROUP_PLANS: function GROUP_PLANS(groupId, profileId) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/groups/").concat(groupId, "/plans?planCandidate_id=").concat(profileId);
    },
    COUPON_PLANS: function COUPON_PLANS(groupId, promocode) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/groups/").concat(groupId, "/plans?promocode=").concat(promocode);
    },
    DISCOUNT_PLAN: function DISCOUNT_PLAN(planId, maxDiscount) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/discount-plan-from-id/").concat(planId, "/").concat(maxDiscount);
    },
    LIMITED_APPLY_PLAN: function LIMITED_APPLY_PLAN(profileId, isTrial) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/limited-apply?profileId=").concat(profileId, "&trial=").concat(isTrial, "&apple=false");
    },
    MONTHLY_PLAN_BY_PRICE: function MONTHLY_PLAN_BY_PRICE(price, profileId, periodicity) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS, "/v1/monthly-plan-by-price/").concat(profileId, "/").concat(price, "?periodicityMonths=").concat(periodicity);
    }
  },
  SUBSCRIPTIONS: {
    UPDATE: function UPDATE(subscriptionId) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS, "/v1/subscriptions/").concat(subscriptionId);
    },
    INSERT: "".concat(process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS, "/v1/subscriptions/"),
    GET: function GET(candidateId) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS, "/v1/subscriptions/?candidate.id=").concat(candidateId);
    },
    IS_LIMITED_APPLY_USER: function IS_LIMITED_APPLY_USER(candidateId) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS, "/v1/subscriptions/is-limited-apply?candidateID=").concat(candidateId);
    },
    TRIALS: function TRIALS(candidateId) {
      return "".concat(process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS, "/v1/subscriptions/trials?candidateID=").concat(candidateId);
    }
  },
  PAYMENT_GATEWAY: {
    LAST_CHARGE: "".concat(process.env.URL_API_PAYMENT_GATEWAY, "/v1/last-charge-status/"),
    SOURCES: function SOURCES(candidateId) {
      return "".concat(process.env.URL_API_PAYMENT_GATEWAY, "/v1/customers/").concat(candidateId, "/sources");
    }
  },
  AUDIT: {
    SAVE_LOAD: "".concat(process.env.URL_MICROSERVICE_AUDITS, "/v1/audits/"),
    SAVE_CREATED: "".concat(process.env.URL_MICROSERVICE_AUDITS, "/v1/candidatesCreate/audits/"),
    SAVE_CANDIDATE_PRICE: "".concat(process.env.URL_MICROSERVICE_AUDITS, "/v1/candidatesPrice/audits")
  },
  BILLING_AUTHENTICATION: {
    ACCESS_TOKEN: "".concat(process.env.URL_BILLING_AUTHENTICATION, "/auth/token")
  },
  BILLING_API: {
    GET_CHARGE_STATUS: function GET_CHARGE_STATUS(candidateId, chargeId) {
      return "".concat(process.env.URL_BILLING_API, "/v1/customers/").concat(candidateId, "/charges/status/").concat(chargeId);
    },
    GET_CHARGE_STATUS_V2: function GET_CHARGE_STATUS_V2(candidateId, chargeId) {
      return "".concat(process.env.URL_BILLING_API, "/v2/customers/").concat(candidateId, "/charges/").concat(chargeId, "/status");
    }
  },
  BANKSLIP: {
    GET: "".concat(process.env.URL_MICROSERVICE_BANKSLIP)
  },
  CARD_VALIDATOR: {
    VALIDATE: "".concat(process.env.URL_MICROSERVICE_CARD_VALIDATOR, "/validate/bin")
  },
  USER: {
    USER_API: function USER_API(candidateId) {
      return "".concat(process.env.URL_USER_API_MOSSAD, "/").concat(candidateId);
    },
    AUTHENTICATION_INFO: function AUTHENTICATION_INFO(candidateId) {
      return "".concat(process.env.URL_USER_API, "/").concat(candidateId, "/autenticacao");
    },
    PHOTO: function PHOTO(candidateId) {
      return "".concat(process.env.URL_CATHO_PHOTO, "/").concat(candidateId, ".foto/");
    },
    SIGNOUT_URL: process.env.USER_AUTH_SIGNOUT_URL,
    AUTH_API_KEY: "".concat(process.env.USER_AUTH_API_KEY)
  },
  CONSENTS: {
    API_KEY: "".concat(process.env.MICROSERVICE_CONSENTS_API_KEY),
    CONTRACT_URL: function CONTRACT_URL() {
      var contractType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CONTRACTS.default.UPGRADE;
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return "".concat(process.env.MICROSERVICE_CONSENTS_URL, "/terms/").concat(contractId[contractType], "/versions/").concat(version);
    },
    TERMS_AND_CONDITIONS_URL: function TERMS_AND_CONDITIONS_URL() {
      var termType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CONTRACTS.default.TERMS_AND_CONDITIONS;
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return "".concat(process.env.MICROSERVICE_CONSENTS_URL, "/terms/").concat(contractId[termType], "/versions/").concat(version);
    },
    ACCEPT_URL: "".concat(process.env.MICROSERVICE_CONSENTS_URL, "/consents"),
    CONTRACT_UUID: function CONTRACT_UUID() {
      var contractType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CONTRACTS.default.UPGRADE;
      return "".concat(contractId[contractType]);
    },
    TERM_UUID: function TERM_UUID() {
      var contractType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CONTRACTS.default.TERMS_AND_CONDITIONS;
      return "".concat(contractId[contractType]);
    },
    VERSION_URL: function VERSION_URL() {
      var contractType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _CONTRACTS.default.TERMS_AND_CONDITIONS;
      var termVersion = arguments.length > 1 ? arguments[1] : undefined;
      return "".concat(process.env.MICROSERVICE_CONSENTS_URL, "/consents?termId=").concat(contractId[contractType], "&termVersion=").concat(termVersion, "&latest=true");
    }
  },
  CANDIDATURA: {
    PRIVATE_KEY: "".concat(process.env.MICROSERVICE_CANDIDATURA_PRIVATE_KEY),
    APPLICATION_URL: "".concat(process.env.MICROSERVICE_CANDIDATURA_URL, "/v2/candidaturas")
  },
  GEOIP: {
    GET: function GET(ip) {
      return "".concat(process.env.MICROSERVICE_GEOIP_URL, "/json/").concat(ip);
    }
  },
  MAILER: {
    API_URL: process.env.MAILER_API_URL,
    API_KEY: process.env.MAILER_API_KEY
  },
  STANDOUT: {
    TOKEN: process.env.STANDOUT_API_TOKEN,
    HTTP_PROXY: process.env.STANDOUT_HTTP_PROXY,
    USER_RANK_POSITION: "".concat(process.env.URL_STANDOUT_API, "/cv_rank_position/user")
  },
  EXPERIMENT: {
    URL: process.env.URL_MICROSERVICE_EXPERIMENT,
    NAME_ID: process.env.EXPERIMENT_NAME_ID,
    FOR_DEVS: process.env.EXPERIMENT_FOR_DEVS,
    HTTP_PROXY: process.env.STANDOUT_HTTP_PROXY
  },
  EVENTBUS: {
    PUBLISH_EVENT: "".concat(process.env.EVENTBUS_API_URL),
    KEY: process.env.EVENTBUS_API_KEY
  },
  APPLY: {
    AVAILABLE: "".concat(process.env.URL_MICROSERVICE_APPLY, "/charged-apply/available/"),
    KEY: process.env.MICROSERVICE_APPLY_API_KEY
  },
  CHECKOUT: {
    APPLY: "".concat(process.env.URL_MICROSERVICE_CHECKOUT, "/charged-apply/checkout/"),
    CVO_SUBSCRIPTION: "".concat(process.env.URL_MICROSERVICE_CHECKOUT, "/cvo-subscription/checkout/plans"),
    CVO_SUBSCRIPTION_TRIAL_PLANS: "".concat(process.env.URL_MICROSERVICE_CHECKOUT, "/trial-plan"),
    CANCEL_CHARGE: "".concat(process.env.URL_MICROSERVICE_CHECKOUT, "/billing-cancel-charge"),
    VISITS: "".concat(process.env.URL_MICROSERVICE_CHECKOUT, "/visits"),
    KEY: process.env.MICROSERVICE_CHECKOUT_API_KEY
  }
};
exports["default"] = _default;

/***/ }),

/***/ 69269:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var CATEGORIES = {
  ACCESS: 'access',
  BACKEND: 'backend',
  REQUEST: 'request'
};
var _default = CATEGORIES;
exports["default"] = _default;

/***/ }),

/***/ 52400:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var errors = {
  GENERIC_ERROR: 'generic-error',
  UNAUTHORIZED: 'unauthorized',
  VALIDATION_ERROR: 'validation-error',
  DEPENDENCY_ERROR: 'dependency-error',
  UNEXPECTED_ERROR: 'unexpected-error',
  INVALID_COUPON: 'invalid-coupon',
  CHARGE_ERROR: 'charge-error',
  FETCH_FAILURE: 'fetch-failure',
  JSON_PARSE_ERROR: 'json-parse-error',
  NOT_FOUND: 'not-found'
};
var _default = errors;
exports["default"] = _default;

/***/ }),

/***/ 20687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(12419);

__webpack_require__(47941);

__webpack_require__(82526);

__webpack_require__(57327);

__webpack_require__(38880);

__webpack_require__(54747);

__webpack_require__(49337);

var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

__webpack_require__(74916);

__webpack_require__(4723);

__webpack_require__(41539);

__webpack_require__(88674);

var _createClass2 = _interopRequireDefault(__webpack_require__(88361));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33227));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(92191));

var _inherits2 = _interopRequireDefault(__webpack_require__(85971));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(52715));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(91193));

var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(36558));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(930));

var _https = _interopRequireDefault(__webpack_require__(78428));

var _axios = _interopRequireDefault(__webpack_require__(43306));

var _uuid = __webpack_require__(67429);

var _loggers = __webpack_require__(82609);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SendHttpReqError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(SendHttpReqError, _Error);

  var _super = _createSuper(SendHttpReqError);

  function SendHttpReqError(message, transactionId) {
    var _this;

    (0, _classCallCheck2.default)(this, SendHttpReqError);
    _this = _super.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "transactionId", "");
    _this.transactionId = transactionId;
    return _this;
  }

  return (0, _createClass2.default)(SendHttpReqError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

var sendHttpReq = function sendHttpReq(_ref) {
  var _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'get' : _ref$method,
      url = _ref.url,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers,
      data = _ref.data,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 60000 : _ref$timeout,
      _ref$maxRedirects = _ref.maxRedirects,
      maxRedirects = _ref$maxRedirects === void 0 ? 5 : _ref$maxRedirects,
      _ref$hasLogs = _ref.hasLogs,
      hasLogs = _ref$hasLogs === void 0 ? true : _ref$hasLogs,
      _ref$hasHeadersLogs = _ref.hasHeadersLogs,
      hasHeadersLogs = _ref$hasHeadersLogs === void 0 ? true : _ref$hasHeadersLogs,
      _ref$hasDataLogs = _ref.hasDataLogs,
      hasDataLogs = _ref$hasDataLogs === void 0 ? true : _ref$hasDataLogs,
      _ref$proxyHttpsAgent = _ref.proxyHttpsAgent,
      proxyHttpsAgent = _ref$proxyHttpsAgent === void 0 ? null : _ref$proxyHttpsAgent;

  var reqHeaders = _objectSpread({}, headers);

  if (data) reqHeaders['content-type'] = 'application/json';
  var transactionId = reqHeaders['x-transaction-id'] || (0, _uuid.v4)();
  reqHeaders['x-transaction-id'] = transactionId;
  var requestInfo = {
    method: method,
    url: url,
    headers: reqHeaders,
    data: data,
    timeout: timeout,
    maxRedirects: maxRedirects
  };
  var HIDDEN = 'HIDDEN';
  hasLogs && _loggers.requestLogger.debug({
    message: 'Sending request..',
    method: method,
    url: requestInfo.url,
    transactionId: transactionId,
    headers: hasHeadersLogs ? requestInfo.headers : HIDDEN,
    data: hasDataLogs ? requestInfo.data : HIDDEN
  });
  var httpsAgent = null;

  if (proxyHttpsAgent) {
    httpsAgent = proxyHttpsAgent;
  } else {
    httpsAgent = new _https.default.Agent({
      rejectUnauthorized: false
    });
  }

  return _axios.default.request(_objectSpread(_objectSpread({}, requestInfo), {}, {
    httpsAgent: httpsAgent
  })).then(function (resp) {
    var respInfo = {
      status: resp.status,
      headers: resp.headers,
      data: resp.data,
      transactionId: transactionId
    };
    hasLogs && _loggers.requestLogger.info({
      message: 'Request succeeded!',
      statusCode: respInfo.status,
      method: method,
      requestUrl: url,
      transactionId: transactionId
    });
    hasLogs && _loggers.requestLogger.debug({
      statusCode: respInfo.status,
      requestUrl: requestInfo.url,
      headers: hasHeadersLogs ? respInfo.headers : HIDDEN,
      data: hasDataLogs ? respInfo.data : HIDDEN,
      transactionId: transactionId
    });
    return respInfo;
  }).catch(function (errResp) {
    if (errResp.response) {
      var respInfo = {
        status: errResp.response.status,
        headers: errResp.response.headers,
        data: errResp.response.data,
        transactionId: transactionId
      };
      hasLogs && _loggers.requestLogger.info({
        message: 'Request fell out of 2XX range',
        statusCode: respInfo.status,
        method: method,
        requestUrl: url,
        transactionId: transactionId
      });
      hasLogs && _loggers.requestLogger.debug({
        requestUrl: requestInfo.url,
        statusCode: respInfo.status,
        headers: hasHeadersLogs ? respInfo.headers : HIDDEN,
        data: hasDataLogs ? respInfo.data : HIDDEN,
        transactionId: transactionId
      });
      return respInfo;
    }

    var errMsg = "Failed to setup request: ".concat(errResp.message);
    var statusCode = 500;

    if (errResp.message.match(/timeout/)) {
      errMsg = errResp.message;
      statusCode = -1;
    } else if (errResp.request) {
      errMsg = 'Request sent, no response received';
      statusCode = 504;
    }

    hasLogs && _loggers.requestLogger.error({
      message: errMsg,
      statusCode: statusCode,
      method: method,
      requestUrl: requestInfo.url,
      transactionId: transactionId
    });
    var customError = new SendHttpReqError(errMsg, transactionId);
    return Promise.reject(customError);
  });
};

var _default = sendHttpReq;
exports["default"] = _default;

/***/ }),

/***/ 82609:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


__webpack_require__(47941);

__webpack_require__(82526);

__webpack_require__(57327);

__webpack_require__(41539);

__webpack_require__(38880);

__webpack_require__(54747);

__webpack_require__(49337);

var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.requestLogger = exports.backendLogger = exports.accessLogger = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(930));

var _os = _interopRequireDefault(__webpack_require__(73461));

var _winston = __webpack_require__(15832);

var _uuid = __webpack_require__(67429);

var _LOG_CATEGORIES = _interopRequireDefault(__webpack_require__(69269));

var _networkInterfaces$et, _networkInterfaces$et2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var networkInterfaces = _os.default.networkInterfaces();

var loggerConfig = {
  level: 'info',
  format: _winston.format.combine(_winston.format.json()),
  defaultMeta: {
    tenant: 'candidate-onboarding',
    environment: process.env.APPLICATION_ENV,
    'datacenter-name': process.env.AWS_REGION || 'us-east-1',
    'application-name': process.env.APPLICATION_NAME || 'candidate-checkout-app',
    'application-version': process.env.RELEASE_TAG || 'development',
    'host-ip': (networkInterfaces === null || networkInterfaces === void 0 ? void 0 : (_networkInterfaces$et = networkInterfaces.eth0) === null || _networkInterfaces$et === void 0 ? void 0 : (_networkInterfaces$et2 = _networkInterfaces$et[0]) === null || _networkInterfaces$et2 === void 0 ? void 0 : _networkInterfaces$et2.address) || '0.0.0.0'
  },
  transports: [new _winston.transports.Console({
    level: process.env.LOG_LEVEL
  })]
};
var winstonLogger = (0, _winston.createLogger)(loggerConfig);

var Logger = function Logger(categoryName) {
  return {
    info: function info(data) {
      var isObj = typeof data === 'object';
      var isString = typeof data === 'string';
      var sendData = isObj ? data : {};
      winstonLogger.info(_objectSpread({
        'created-at': new Date().toISOString(),
        'transaction-id': (sendData === null || sendData === void 0 ? void 0 : sendData.transactionId) || (0, _uuid.v4)(),
        label: categoryName,
        message: data && isString ? data : "info - ".concat(categoryName)
      }, sendData));
    },
    error: function error(data) {
      var isObj = typeof data === 'object';
      var isString = typeof data === 'string';
      var sendData = isObj ? data : {};
      winstonLogger.error(_objectSpread({
        'created-at': new Date().toISOString(),
        'transaction-id': (sendData === null || sendData === void 0 ? void 0 : sendData.transactionId) || (0, _uuid.v4)(),
        label: categoryName,
        message: data && isString ? data : "error - ".concat(categoryName)
      }, sendData));
    },
    warn: function warn(data) {
      var isObj = typeof data === 'object';
      var isString = typeof data === 'string';
      var sendData = isObj ? data : {};
      winstonLogger.warn(_objectSpread({
        'created-at': new Date().toISOString(),
        'transaction-id': (sendData === null || sendData === void 0 ? void 0 : sendData.transactionId) || (0, _uuid.v4)(),
        label: categoryName,
        message: data && isString ? data : "warn - ".concat(categoryName)
      }, sendData));
    },
    debug: function debug(data) {
      var isObj = typeof data === 'object';
      var isString = typeof data === 'string';
      var sendData = isObj ? data : {};
      winstonLogger.debug(_objectSpread({
        'created-at': new Date().toISOString(),
        'transaction-id': (sendData === null || sendData === void 0 ? void 0 : sendData.transactionId) || (0, _uuid.v4)(),
        label: categoryName,
        message: data && isString ? data : "debug - ".concat(categoryName)
      }, sendData));
    }
  };
};

var accessLogger = Logger(_LOG_CATEGORIES.default.ACCESS);
exports.accessLogger = accessLogger;
var backendLogger = Logger(_LOG_CATEGORIES.default.BACKEND);
exports.backendLogger = backendLogger;
var requestLogger = Logger(_LOG_CATEGORIES.default.REQUEST);
exports.requestLogger = requestLogger;

/***/ }),

/***/ 97165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(41539);

__webpack_require__(12419);

var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TypedErrorField = exports.TypedError = void 0;

var _createClass2 = _interopRequireDefault(__webpack_require__(88361));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(33227));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(92191));

var _inherits2 = _interopRequireDefault(__webpack_require__(85971));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(52715));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(91193));

var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(36558));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(930));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TypedError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(TypedError, _Error);

  var _super = _createSuper(TypedError);

  function TypedError(message, type) {
    var _this;

    (0, _classCallCheck2.default)(this, TypedError);
    _this = _super.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "type", "");
    _this.type = type;
    return _this;
  }

  return (0, _createClass2.default)(TypedError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.TypedError = TypedError;

var TypedErrorField = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(TypedErrorField, _Error2);

  var _super2 = _createSuper(TypedErrorField);

  function TypedErrorField() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var legacyMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    (0, _classCallCheck2.default)(this, TypedErrorField);
    _this2 = _super2.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "type", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "field", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "legacyMessage", "");
    _this2.type = type;
    _this2.field = field;
    _this2.legacyMessage = legacyMessage;
    return _this2;
  }

  return (0, _createClass2.default)(TypedErrorField);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.TypedErrorField = TypedErrorField;

var _default = function _default(message, type) {
  var error = new TypedError(message, type);
  throw error;
};

exports["default"] = _default;

/***/ }),

/***/ 76647:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52361:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 94616:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85811:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 62828:
/***/ (function() {

/* (ignored) */

/***/ })

}]);